import './lib/sentry'; // Инициализация Sentry
// Сохраняем флаг тестировщика ДО маршрутизации
if (new URLSearchParams(window.location.search).get("tester") === "1") {
  localStorage.setItem("bug_tester_mode", "1");
}

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
